import { render, staticRenderFns } from "./breakdowns-modal-basic-form.vue?vue&type=template&id=756233c5&"
import script from "./breakdowns-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./breakdowns-modal-basic-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports